module.exports = require('./lib/patch');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-hot-loader/patch.js
// module id = 549
// module chunks = 0